const PURGE = "chapter/PURGE";
const SET_CHAPTER_LANG_LIST = "chapter/SET_CHAPTER_LANG_LIST";
const SET_CHAPTER_LIST = "chapter/SET_CHAPTER_LIST";
const SET_SELECTED_CHAPTER = "chapter/SET_SELECTED_CHAPTER";
const SET_CHAP_STATE = "chapter/SET_CHAP_STATE";
const SET_SELECTED_LANGUAGE = "chapter/SET_SELECTED_LANGUAGE";
const ADD_CHAPTER = "chapter/ADD_CHAPTER";
const DELETE_CHAPTER = "chapter/DELETE_CHAPTER";
const UPDATE_CHAPTER = "chapter/UPDATE_CHAPTER";

// 액션 생성 함수
export const purgeChapter = () => ({ type: PURGE });
export const setChapterLangList = chapterLangList => ({ type: SET_CHAPTER_LANG_LIST, chapterLangList });
export const setChapterList = chapterList => ({ type: SET_CHAPTER_LIST, chapterList });
export const setSelectedChapter = selectedChapter => ({ type: SET_SELECTED_CHAPTER, selectedChapter });
export const setChapState = chapState => ({ type: SET_CHAP_STATE, chapState });
export const setSelectedLanguage = selectedLanguage => ({ type: SET_SELECTED_LANGUAGE, selectedLanguage });
export const addChapter = (idx, newChapter) => ({
  type: ADD_CHAPTER,
  payload: { idx, newChapter }
});
export const deleteChapter = (idx) => ({
  type: DELETE_CHAPTER,
  payload: { idx }
});
export const updateChapter = (idx, updatedFields) => ({
  type: UPDATE_CHAPTER,
  payload: { idx, updatedFields }
});

// 초깃값 (상태가 객체가 아니라 그냥 숫자여도 상관 없습니다.)
const initialState = {
  chapterList: [],
  chapterLangList: [],
  selectedChapter: null,
  chapterState: [],
  selectedLanguage: null
}

export default function chapter(state = initialState, action) {
  switch (action.type) {
    case PURGE:
      return {
        ...initialState
      }
    case SET_CHAPTER_LANG_LIST:
      return {
        ...state,
        chapterLangList: action.chapterLangList
      }
    case SET_CHAPTER_LIST:
      return {
        ...state,
        chapterList: action.chapterList
      }
    case SET_SELECTED_CHAPTER:
      return {
        ...state,
        selectedChapter: action.selectedChapter
      }
    case SET_CHAP_STATE:
      return {
        ...state,
        chapState: action.chapState
      }
    case SET_SELECTED_LANGUAGE:
      return {
        ...state,
        selectedLanguage: action.selectedLanguage
      }
    case ADD_CHAPTER: {
      const { idx, newChapter } = action.payload;
      const newList = [
        ...state.chapterList.slice(0, idx + 1),
        newChapter,
        ...state.chapterList.slice(idx + 1)
      ];
      return {
        ...state,
        chapterList: newList
      };
    }
    case DELETE_CHAPTER: {
      const { idx } = action.payload;
      const newList = [...state.chapterList];
      newList.splice(idx, 1);

      if (newList.length === 0) {
        return {
          ...state,
          chapterList: []
        };
      }

      return {
        ...state,
        chapterList: newList
      };
    }
    case UPDATE_CHAPTER: {
      const { idx, updatedFields } = action.payload;
      const newList = [...state.chapterList];
      newList[idx] = {
        ...newList[idx],
        ...updatedFields
      };
      return {
        ...state,
        chapterList: newList
      };
    }
    default:
      return state;
  }
}